module.exports = __webpack_public_path__ + "static/media/cort-furniture-square_2x.81e38cd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/cort-furniture-square_2x.png
// module id = 758
// module chunks = 27